import { render, staticRenderFns } from "./tribeCreate.vue?vue&type=template&id=1479827e&scoped=true&"
import script from "./tribeCreate.vue?vue&type=script&lang=js&"
export * from "./tribeCreate.vue?vue&type=script&lang=js&"
import style0 from "./tribeCreate.vue?vue&type=style&index=0&id=1479827e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1479827e",
  null
  
)

export default component.exports